// extracted by mini-css-extract-plugin
export default {"item":"Item-module__item___M38oN"};